import type {ConversationContext} from '@stripe-internal/conversations-client';

export type ConversationTransition = 'rac' | 'email' | 'restart';

export function observeConversationTransitions({
  initialContext,
  emailEnabled,
  transition,
}: {
  initialContext: ConversationContext;
  emailEnabled?: boolean;
  transition: (kind: ConversationTransition) => void;
}) {
  let previous = initialContext;
  return (context: ConversationContext) => {
    const channelChanged = context.channel !== previous.channel;
    const restarted =
      context.intent !== previous.intent &&
      context.intent === 'restart_conversation';
    previous = context;
    if (channelChanged && context.channel === 'request_a_call') {
      transition('rac');
    }
    if (channelChanged && context.channel === 'email' && emailEnabled) {
      transition('email');
    }
    if (restarted) {
      transition('restart');
    }
  };
}
